var version = {
    "name":      "dativery",
    "buildDateCode": "20260519-081329",
    "buildDate": "Tue May 19 2026 08:13:29 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260519-081329",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;